import { atom } from 'jotai';
import type { LocalAudioRecord } from './types';

/** Currently selected profile id — pure UI state. */
export const selectedProfileIdAtom = atom<string>('');

/**
 * Local recordings that have not yet reached the server.
 * Source of truth is the client (IndexedDB + in-memory), not the API —
 * this is an intentional exception to the "server state in Query" rule.
 */
export const pendingAudioByProfileIdAtom = atom<Record<string, LocalAudioRecord[]>>({});

/** @deprecated Use pendingAudioByProfileIdAtom */
export const localAudioByProfileIdAtom = pendingAudioByProfileIdAtom;
